/**
 * @ComponentFor EPiServer.Core.ContentArea
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { State, resolveSyncIfLoadedOrThrow } from '@avensia/scope';
import { supportsComponentProp, supportsComponentPropName, ComponentType } from '../EpiProperty';

type ContentAreaAttributes = { [attr: string]: string };

type ContentAreaItemProps = {
  className?: string;
  wrappingAttrs: ContentAreaAttributes;
  item: any;
  component: React.ComponentType<any>;
};

class ContentAreaItem extends React.Component<ContentAreaItemProps> {
  base = (props: any) => <div {...this.props.wrappingAttrs} {...props} />;
  render() {
    const passThroughProps: { className?: string } = {};
    if (this.props.className) {
      passThroughProps.className = this.props.className;
    }

    if ((this.props.component as any)[supportsComponentPropName]) {
      return <this.props.component {...passThroughProps} {...this.props.item} component={this.base} />;
    } else {
      return (
        <div {...passThroughProps} {...this.props.wrappingAttrs}>
          <this.props.component {...this.props.item} />
        </div>
      );
    }
  }
}

export function contentAreaItems(propertyName?: string, items?: any[], currentTheme?: string) {
  return (items || []).filter(i => !!i).map((item, i) => {
    const Component = resolveSyncIfLoadedOrThrow(item.componentName, currentTheme);
    const itemAttrs =
      window.IS_IN_EDIT_MODE && propertyName
        ? {
            'data-epi-block-id': item.$idForOnPageEditing,
            'data-epi-block-info': '{&quot;missingrenderer&quot;:false}',
          }
        : ({} as ContentAreaAttributes);
    return <ContentAreaItem key={i} component={Component} item={item} wrappingAttrs={itemAttrs} />;
  });
}

export type ContentAreaProps = Scope.ContentArea & {
  component?: ComponentType;
  className?: string;
  propertyName?: string;
};

type ConnectedProps = {
  currentTheme: string;
};

export default supportsComponentProp(
  connect(
    (state: State): ConnectedProps => ({
      currentTheme: state.currentTheme,
    }),
  )(
    ({
      component: Component = 'div',
      className = '',
      propertyName,
      items,
      currentTheme,
    }: ContentAreaProps & ConnectedProps) => (
      <Component className={className}>{contentAreaItems(propertyName, items, currentTheme)}</Component>
    ),
  ),
);
